import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './BlogPage.css';

const BlogPage = () => {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        
        // First check if Supabase is initialized
        if (!supabase) {
          throw new Error('Supabase client is not initialized');
        }

        // Add error handling for network issues
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout

        const { data, error } = await supabase
          .from('blog_posts')
          .select('*')
          .eq('published', true)
          .order('created_at', { ascending: false })
          .abortSignal(controller.signal);

        clearTimeout(timeoutId);

        if (error) {
          console.error('Error fetching blog posts:', error);
          setError('Failed to load blog posts');
        } else {
          setPosts(data);
          setIsLoading(false);
        }
      } catch (err) {
        console.error('Error in fetchPosts:', {
          error: err,
          message: err.message,
          stack: err.stack
        });
        setError(err.message);
      } finally {
    
        setIsLoading(false);
      }
    };

    fetchPosts();

    // Cleanup function
    return () => {
      setIsLoading(false);
      setPosts([]);
    };
  }, []);

  if (isLoading) {
    return (
      <div className="blog-page">
        <Header />
        <main className="blog-content">
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p className="loading-message">Loading blog posts...</p>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div className="blog-page">
        <Header />
        <main className="blog-content">
          <div className="error-container">
            <p className="error-message">{error}</p>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="blog-page">
      <Header />
      <main className="blog-content">
        <div className="blog-header">
          <h1 className="blog-title">Blog</h1>
          <p className="blog-description">
            Insights, tips, and stories about word learning and language mastery.
          </p>
        </div>

        <div className="blog-posts">
          {posts.map((post) => (
            <article key={post.id} className="blog-post-card">
              {post.featured_image && (
                <div className="post-image">
                  <img src={post.featured_image} alt={post.title} />
                </div>
              )}
              <div className="post-content">
                <h2 className="post-title">
                  <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                </h2>
                {post.excerpt && <p className="post-excerpt">{post.excerpt}</p>}
                <div className="post-meta">
                  <span className="post-date">
                    {new Date(post.created_at).toLocaleDateString()}
                  </span>
                  <span className="post-author">By The Learning Dictionary</span>
                </div>
                <Link to={`/blog/${post.slug}`} className="read-more">
                  Read more →
                </Link>
              </div>
            </article>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default BlogPage; 